module.exports = __webpack_public_path__ + "static/media/YL_getfreelisting_Mobile_EN.f9d60820.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YL_getfreelisting_Mobile_EN.png
// module id = 705
// module chunks = 0